import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { InHomeCareComponent } from './manage/in-home-care.component';
import { ManageInHomeCareChangeComponent } from './manage-in-home-care-change/manage-in-home-care-change.component';
import { InHomeCareManagementComponent } from './in-home-care-management/in-home-care-management.component';
import { InHomeCareAssignedComponent } from './in-home-care-assigned/in-home-care-assigned.component';
import { InHomeCareClaimsComponent } from './in-home-care-claims/in-home-care-claims.component';
import { AuthGuard } from '@shared/auth/auth-guard';
import { ComplaintComponent } from '../reusable/compliance/complaint/complaint.component';

const routes: Routes = [
  { path: 'manage', component: InHomeCareComponent, canActivate: [ AuthGuard ] },
  { path: 'renewal', component: InHomeCareComponent, canActivate: [ AuthGuard ] },
  { path: 'assigned', component: InHomeCareAssignedComponent, canActivate: [ AuthGuard ] },
  { path: 'manage/:id', component: InHomeCareComponent, canActivate: [ AuthGuard ] },
  { path: 'change', component: ManageInHomeCareChangeComponent, canActivate: [ AuthGuard ] },
  { path: 'change/:id', component: ManageInHomeCareChangeComponent, canActivate: [ AuthGuard ] },
  { path: 'reports', component: InHomeCareManagementComponent, canActivate: [ AuthGuard ]},
  { path: 'ownerClaims', component: InHomeCareClaimsComponent, canActivate: [ AuthGuard ]},
  { path: 'claims', component: InHomeCareClaimsComponent, canActivate: [ AuthGuard ]},
  { path: 'complaints/:entity', component: ComplaintComponent, canActivate: [ AuthGuard ]}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class InHomeCareRoutingModule { }
